import React from 'react';
import ReactDOM from 'react-dom/client';
// TODO: added this for to test sentry Error Logger
// import * as Sentry from "@sentry/react";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import { loadTenantConfig } from 'config/tenantConfig';
import { injectTheme } from 'config/themeInjector';

// TODO: added this for to test sentry Error Logger
// Sentry.init({
//   dsn: "https://ec2458afe530242171aa7bf33dea83e2@o4506460456943616.ingest.us.sentry.io/4507050200399872",
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration({
//       maskAllText: false,
//       blockAllMedia: false,
//     }),
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   //TODO: adding this urls for testing purpose
//   tracePropagationTargets: ["localhost", "http://localhost:3000/", "https://qa-corporate.iter.co.in/"],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

const root = ReactDOM.createRoot(document.getElementById('root'));

// Multi-tenancy: ask "whose site is this?" before first paint so the page
// renders in the right tenant's branding. loadTenantConfig never throws and
// times out fast — worst case the built-in Iter look renders, as today.
const boot = async () => {
  injectTheme(await loadTenantConfig());
  root.render(
    <Provider store={store}>
      <App />
    </Provider>,
  );
};
boot();

reportWebVitals();
